import React from 'react'

import i18n from 'translations'

export const Methodologies = [
  {
    name: i18n.t('methodologies:name'),
    component: React.lazy(() =>
      import('../../../modules/admin/pedagogical-parameters/methodologies/MethodologiesList'),
    ),
    path: '/admin/pedagogical-parameters/methodologies',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: i18n.t('methodologies:createMethodologies'),
    component: React.lazy(() =>
      import('../../../modules/admin/pedagogical-parameters/methodologies/MethodologiesCreate'),
    ),
    path: '/admin/pedagogical-parameters/methodologies/create',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: i18n.t('methodologies:editMethodologies'),
    component: React.lazy(() =>
      import('../../../modules/admin/pedagogical-parameters/methodologies/MethodologiesEdit'),
    ),
    path: '/admin/pedagogical-parameters/methodologies/edit/:methodologyId',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
]
